import isObject from "./isObject.js";
import { nativeCreate } from "./_setup.js";
function ctor() {
  return function() {
  };
}
export default function baseCreate(prototype) {
  if (!isObject(prototype)) return {};
  if (nativeCreate) return nativeCreate(prototype);
  var Ctor = ctor();
  Ctor.prototype = prototype;
  var result = new Ctor();
  Ctor.prototype = null;
  return result;
}
